key = 'canasta:games'

Storage = {
	getGames: () ->
		JSON.parse(localStorage[key] ? '[]')
	storeGames: (games) ->
		localStorage[key] = JSON.stringify games
}

module.exports = Storage